"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.gbCompanyNumberChecker = void 0;
// UTR should be either 10 or 13 digits
var UTR_REGEX = /^(\d{10}|\d{13})$/;

// CRN patterns:
// 1. 0 followed by 7 digits
// 2. OC/SC/SO followed by 6 digits
// 3. 0 followed by 6 digits and then LTC or PLC
var CRN_REGEX = /^(0\d{7}|(OC|SC|SO)\d{6}|0\d{6}(LTC|PLC))$/;
var isValidUtr = function isValidUtr(utr) {
  var cleanUtr = utr.replace(/\s+/g, '');
  return UTR_REGEX.test(cleanUtr);
};
var isValidCrn = function isValidCrn(crn) {
  var cleanCrn = crn.trim().toUpperCase();
  return CRN_REGEX.test(cleanCrn);
};
var gbCompanyNumberChecker = exports.gbCompanyNumberChecker = function gbCompanyNumberChecker(companyNumber) {
  return isValidUtr(companyNumber) || isValidCrn(companyNumber);
};